<template>
  <div class="containerP">
   <topoDecla />
   <p class="txtDecla">Declarações Federais</p>
   <div style="display: flex;    justify-content: center;    align-items: center;    margin-top: 20px;">
   <div class="ordenacao">
     <div class="ordenacaoAtual" @click="mostrarOrde = !mostrarOrde">
       <p> <span class="seta"></span>  <span>Ordenação:</span> {{autalOrdenacao}} </p>
     </div>
     <div v-show="mostrarOrde" class="m">
      <div class="ordenacaoOp" style="background: #EAE7F2;" @click="ordenar('Cronológica')">
        <p><span>Ordenação</span> Cronológica</p>
      </div>
      <div class="ordenacaoOp" @click="ordenar('Alfábética')"> 
        <p><span>Ordenação</span> Alfábética</p>
      </div>
     </div>
   </div>
   </div>
   <Conteudo  v-if="$store.state.spiner"/> 
   <Spiner v-else />
  </div>
</template>

<script>
import Conteudo from '../components/Conteudo.vue'
import Spiner from '../components/Spiner.vue'
import config from '../services/config'
export default {
components:{
  Conteudo,
  Spiner
},
data(){
  return{
    autalOrdenacao:'Cronológica',
    mostrarOrde:false
  }
},
methods:{
  data(dados){
   dados.forEach(element => {
      if(element.data.length != 0 && element.data != ""){
              let data = element.data.split('-')
              data = data[2] +'/'+data[1]+"/"+data[0]
              element.data = data
      }
            });
  },
  async ordenar(params){
    this.mostrarOrde = false
    this.autalOrdenacao = params
    let hash = JSON.parse(localStorage.getItem('objCli'))
    let obj = {"hash":hash.hash,"uf":'fed', "tipo":params == 'Cronológica'? 'd' : 't'}
  this.$store.state.spiner = false
    localStorage.setItem("declaracoes",  JSON.stringify(obj));
  this.$store.state.dados  = await config.buscar(obj)
  this.data(this.$store.state.dados)
             this.$store.state.spiner = true
  }
},  
async created(){
  let hash = JSON.parse(localStorage.getItem('objCli'))
  let obj = {"hash":hash.hash,"uf":'fed', "tipo":"d"}
  this.$store.state.spiner = false
    localStorage.setItem("declaracoes",  JSON.stringify(obj));
  this.$store.state.dados  = await config.buscar(obj)
  this.data(this.$store.state.dados)
             this.$store.state.spiner = true
}

}
</script>

<style>
.m{
  border-top: none;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-left: 2px solid;
    height: 80px;
    padding-top: 5px;
    border-image: initial;
    margin-top: -4px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    position: relative;
    z-index: 1;
}
.seta{  
   border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #4A154B;
   display: inline-block;
}
.ordenacao{
  width: 216px;
height: 35px;
border: 2px solid #4A154B;
border-radius: 10px;
font-size: 14px;

}
.ordenacao p{
color: #4A154B;
font-weight: 600;
}
.ordenacao span{
  font-weight: bold;
}
.ordenacaoAtual{
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
height: 32px;
}
.ordenacaoOp{
  display: flex;
justify-content: center;
align-items: center;
height: 35px;
cursor: pointer;
}
</style>